import React from "react";
import styled from "styled-components";

const StyledButton = styled.button``;

const ButtonSubmit = ({ label, formIsValid }) => {
  return (
    <StyledButton
      className={"btn btn-primary"}
      type="submit"
      disabled={!formIsValid}
    >
      {label}
    </StyledButton>
  );
};

export default ButtonSubmit;
